<template lang="pug">
    div 
        div(v-html="computedValue")
</template>
<script>
// https://github.com/vuejs/vue/issues/4405
// I'd just use computed properties instead or a plain method call. Filters are designed for readability and are expected to be static.
import { vueTextFilters } from "@/libs/rcmTableFieldsFunction";
export default {
    props: ["formItem", "formData", "value"],
    computed: {
        computedValue() {
            if (this.formItem.formRenderTextFormat) {
                let { filter, format = "" } = this.formItem.formRenderTextFormat;
                return vueTextFilters[filter](this.value, format);
            }
            return this.value;
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/rcmTableFormItems/TextOnly.vue